function createSeeProductButton(productGridElement) {
    const productHandle = productGridElement.getAttribute("data-product-handle");
    const productUrl = `/products/${productHandle}`;
    
  
    const seeProductButton = document.createElement("button");
    seeProductButton.textContent = "Acheter";
    seeProductButton.classList.add("button", "button--primary");
    seeProductButton.addEventListener("click", () => {
      window.location.href = productUrl;
    });
  
    productGridElement.appendChild(seeProductButton);
  }
  const productGridElements = document.querySelectorAll(".blog-product-grid");
  productGridElements.forEach(createSeeProductButton);